import { render, staticRenderFns } from "./AiComparation.vue?vue&type=template&id=fb882820"
import script from "./AiComparation.vue?vue&type=script&lang=js"
export * from "./AiComparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports